export interface Comic {
  id: number;
  title: string;
  author: string;
  cover: string;
  category: string;
  description: string;
  rating: number;
  views: number;
  chapters: number;
  status: '连载中' | '已完结';
  updatedAt: string;
  tags: string[];
  featured: boolean;
  trending: boolean;
}

export const comics: Comic[] = [
  {
    id: 1,
    title: '她的私密世界',
    author: '金敏秀',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20webtoon%20cover%20illustration%20featuring%20a%20young%20woman%20with%20flowing%20dark%20hair%20in%20a%20romantic%20setting%2C%20soft%20pastel%20color%20palette%20with%20cherry%20blossom%20petals%2C%20modern%20anime%20art%20style%2C%20clean%20composition%2C%20gentle%20warm%20lighting%2C%20vertical%20orientation%2C%20simple%20elegant%20background&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    category: 'romance',
    description: '普通上班族林小雨偶然发现同事的秘密后，生活发生了翻天覆地的变化。一段甜蜜又纠结的办公室恋情悄然展开。',
    rating: 9.6,
    views: 1520000,
    chapters: 87,
    status: '连载中',
    updatedAt: '2026-08-04',
    tags: ['恋爱', '办公室', '甜宠'],
    featured: true,
    trending: true,
  },
  {
    id: 2,
    title: '剑与魔法纪元',
    author: '朴正宇',
    cover: 'https://readdy.ai/api/search-image?query=A%20fantasy%20Korean%20manhwa%20cover%20featuring%20a%20warrior%20holding%20a%20glowing%20magical%20sword%20in%20an%20epic%20battle%20scene%2C%20dramatic%20lighting%20with%20sparks%20and%20magic%20effects%2C%20dark%20fantasy%20atmosphere%2C%20detailed%20character%20design%2C%20vertical%20cover%20format%2C%20simple%20dark%20background&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    category: 'fantasy',
    description: '在剑与魔法并存的世界里，少年艾伦踏上了成为最强剑士的冒险之旅。史诗级奇幻巨作，世界观宏大。',
    rating: 9.8,
    views: 2310000,
    chapters: 124,
    status: '连载中',
    updatedAt: '2026-08-03',
    tags: ['奇幻', '冒险', '战斗'],
    featured: true,
    trending: true,
  },
  {
    id: 3,
    title: '最后的猎人',
    author: '崔志浩',
    cover: 'https://readdy.ai/api/search-image?query=A%20thriller%20Korean%20manhwa%20cover%20showing%20a%20mysterious%20detective%20in%20a%20dark%20alley%20with%20rain%2C%20noir%20aesthetic%20with%20neon%20signs%20reflecting%20on%20wet%20pavement%2C%20tense%20atmosphere%2C%20modern%20urban%20setting%2C%20clean%20vertical%20composition%2C%20simple%20dark%20background&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    category: 'thriller',
    description: '退休刑警为追查一桩尘封多年的悬案重返江湖。步步逼近的真相，令人窒息的悬疑氛围。',
    rating: 9.5,
    views: 980000,
    chapters: 56,
    status: '连载中',
    updatedAt: '2026-08-02',
    tags: ['悬疑', '推理', '犯罪'],
    featured: true,
    trending: false,
  },
  {
    id: 4,
    title: '校园狂想曲',
    author: '李恩雅',
    cover: 'https://readdy.ai/api/search-image?query=A%20bright%20comedy%20Korean%20manhwa%20cover%20with%20high%20school%20students%20laughing%20together%20in%20a%20classroom%20setting%2C%20vibrant%20colorful%20art%20style%2C%20cheerful%20atmosphere%2C%20slice%20of%20life%20vibe%2C%20clean%20fun%20composition%2C%20vertical%20format%2C%20simple%20bright%20background&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    category: 'comedy',
    description: '一群性格迥异的高中生在校园里上演的爆笑日常。笑中带泪，青春无敌！',
    rating: 9.3,
    views: 1870000,
    chapters: 102,
    status: '连载中',
    updatedAt: '2026-08-04',
    tags: ['搞笑', '校园', '青春'],
    featured: false,
    trending: true,
  },
  {
    id: 5,
    title: '暗影行动',
    author: '姜东旭',
    cover: 'https://readdy.ai/api/search-image?query=An%20action%20Korean%20manhwa%20cover%20with%20a%20skilled%20fighter%20in%20dynamic%20combat%20pose%2C%20martial%20arts%20action%20scene%2C%20intense%20energy%20effects%2C%20urban%20night%20setting%2C%20cool%20dark%20tone%2C%20clean%20vertical%20composition%2C%20simple%20dark%20background&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    category: 'action',
    description: '退役特种兵为保护家人重出江湖，拳拳到肉的格斗场面，热血沸腾的战斗故事。',
    rating: 9.4,
    views: 1650000,
    chapters: 78,
    status: '连载中',
    updatedAt: '2026-08-01',
    tags: ['动作', '格斗', '热血'],
    featured: false,
    trending: true,
  },
  {
    id: 6,
    title: '命运之轮',
    author: '尹熙真',
    cover: 'https://readdy.ai/api/search-image?query=A%20drama%20Korean%20manhwa%20cover%20depicting%20two%20people%20standing%20back%20to%20back%20under%20a%20dramatic%20sunset%20sky%2C%20emotional%20atmosphere%2C%20warm%20golden%20light%2C%20melancholic%20vibe%2C%20beautiful%20character%20art%2C%20vertical%20format%2C%20simple%20sunset%20background&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    category: 'drama',
    description: '两个来自不同世界的人，因命运的安排相遇相知。一段跨越阶层的感人故事，直击心灵。',
    rating: 9.7,
    views: 2100000,
    chapters: 95,
    status: '连载中',
    updatedAt: '2026-08-04',
    tags: ['剧情', '爱情', '人生'],
    featured: true,
    trending: true,
  },
  {
    id: 7,
    title: '午夜诊所',
    author: '韩素英',
    cover: 'https://readdy.ai/api/search-image?query=A%20horror%20Korean%20manhwa%20cover%20with%20an%20eerie%20abandoned%20hospital%20corridor%2C%20dark%20atmosphere%20with%20flickering%20lights%2C%20creepy%20shadow%20figure%20in%20the%20distance%2C%20psychological%20thriller%20style%2C%20dramatic%20lighting%2C%20vertical%20format%2C%20simple%20dark%20background&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    category: 'horror',
    description: '凌晨三点开门的神秘诊所，每个来访者都带着不可告人的秘密。心理恐惧与超自然元素的完美融合。',
    rating: 9.2,
    views: 890000,
    chapters: 42,
    status: '连载中',
    updatedAt: '2026-07-30',
    tags: ['恐怖', '超自然', '心理'],
    featured: false,
    trending: false,
  },
  {
    id: 8,
    title: '咖啡与猫',
    author: '朴智慧',
    cover: 'https://readdy.ai/api/search-image?query=A%20cozy%20slice%20of%20life%20Korean%20manhwa%20cover%20with%20a%20warm%20cafe%20interior%20and%20a%20fluffy%20orange%20cat%20on%20the%20counter%2C%20soft%20gentle%20lighting%2C%20relaxing%20atmosphere%2C%20warm%20brown%20and%20cream%20tones%2C%20vertical%20format%2C%20simple%20warm%20background&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    category: 'daily',
    description: '辞职开了一家猫咪咖啡馆的女孩，与四只猫咪和来往客人之间温暖治愈的日常故事。',
    rating: 9.1,
    views: 720000,
    chapters: 38,
    status: '连载中',
    updatedAt: '2026-08-03',
    tags: ['日常', '治愈', '猫咪'],
    featured: false,
    trending: false,
  },
  {
    id: 9,
    title: '朝鲜王朝秘史',
    author: '安泰勋',
    cover: 'https://readdy.ai/api/search-image?query=A%20historical%20Korean%20manhwa%20cover%20showing%20a%20nobleman%20in%20traditional%20Joseon%20dynasty%20hanbok%20standing%20in%20an%20ancient%20palace%20courtyard%2C%20elegant%20traditional%20art%20style%2C%20soft%20ink%20wash%20aesthetics%2C%20historical%20atmosphere%2C%20vertical%20format%2C%20simple%20beige%20background&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    category: 'historical',
    description: '以朝鲜王朝中宗时期为背景，讲述一段被历史遗忘的王室秘闻。精致的历史考据与动人故事。',
    rating: 9.9,
    views: 1980000,
    chapters: 68,
    status: '已完结',
    updatedAt: '2026-06-15',
    tags: ['历史', '宫廷', '剧情'],
    featured: true,
    trending: false,
  },
  {
    id: 10,
    title: '游戏人生',
    author: '郑允浩',
    cover: 'https://readdy.ai/api/search-image?query=A%20fantasy%20game%20themed%20Korean%20manhwa%20cover%20with%20a%20character%20wearing%20VR%20headset%20with%20digital%20effects%20surrounding%2C%20cyberpunk%20aesthetic%2C%20neon%20colors%2C%20virtual%20reality%20theme%2C%20dynamic%20composition%2C%20vertical%20format%2C%20simple%20dark%20background&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    category: 'fantasy',
    description: '被困在虚拟现实游戏中的玩家们，为了回到现实世界必须通关所有关卡。设定新颖，节奏紧凑。',
    rating: 9.5,
    views: 1430000,
    chapters: 61,
    status: '连载中',
    updatedAt: '2026-08-02',
    tags: ['奇幻', '游戏', '冒险'],
    featured: false,
    trending: true,
  },
  {
    id: 11,
    title: '初恋的味道',
    author: '宋美妍',
    cover: 'https://readdy.ai/api/search-image?query=A%20sweet%20romance%20Korean%20manhwa%20cover%20with%20a%20young%20couple%20sharing%20ice%20cream%20in%20a%20summer%20park%2C%20soft%20pastel%20pink%20and%20sky%20blue%20color%20palette%2C%20dreamy%20atmosphere%2C%20youthful%20energy%2C%20vertical%20format%2C%20simple%20bright%20background&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    category: 'romance',
    description: '高中时期懵懂的初恋，十年后重逢时的心动。甜到发齁的纯爱故事，唤醒每个人的初恋记忆。',
    rating: 9.4,
    views: 1760000,
    chapters: 73,
    status: '已完结',
    updatedAt: '2026-05-20',
    tags: ['恋爱', '校园', '纯爱'],
    featured: false,
    trending: false,
  },
  {
    id: 12,
    title: '深渊之下',
    author: '金泰亨',
    cover: 'https://readdy.ai/api/search-image?query=A%20dark%20fantasy%20thriller%20Korean%20manhwa%20cover%20with%20a%20deep%20underwater%20abyss%20scene%2C%20mysterious%20creature%20silhouette%20in%20the%20darkness%2C%20cold%20blue%20and%20black%20tones%2C%20atmospheric%20horror%2C%20vertical%20format%2C%20simple%20dark%20background&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    category: 'thriller',
    description: '深海探测队在万米海底发现神秘文明遗迹，随之而来的是无法解释的诡异事件接连发生。',
    rating: 9.6,
    views: 1120000,
    chapters: 49,
    status: '连载中',
    updatedAt: '2026-07-28',
    tags: ['悬疑', '科幻', '深海'],
    featured: false,
    trending: false,
  },
];

export const getComicsByCategory = (categorySlug: string): Comic[] => {
  if (categorySlug === 'all') return comics;
  return comics.filter((c) => c.category === categorySlug);
};

export const getFeaturedComics = (): Comic[] => comics.filter((c) => c.featured);

export const getTrendingComics = (): Comic[] => comics.filter((c) => c.trending);

export const getLatestComics = (): Comic[] =>
  [...comics].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime());

export const getComicById = (id: number): Comic | undefined => comics.find((c) => c.id === id);